<template>
    <slot />
</template>

<script setup>
    import { ref, watch, watchEffect } from 'vue';

    import { basePaneOptions, usePane } from '@resn/gozer-vue';

    import { useBaseball } from '../../common/Objects/useBaseball';
    import { useSceneObject } from './useSceneObject';
    import { useModelExporter } from '~/composables/useModelExporter';

    const props = defineProps({
        visible: { type: Boolean, default: false },
        object: { type: Object, default: null, required: true },
        layer: { type: Number, default: 0 },
        x: { type: Number, default: 0 },
        y: { type: Number, default: 0 },
        z: { type: Number, default: 0 },
        s: { type: Number, default: 0.95 },
        rx: { type: Number, default: 0 },
        ry: { type: Number, default: 0 },
        rz: { type: Number, default: 0.8 },
    });

    const stitchesColor = ref('#fb4f3e');
    const rx = ref(props.rx);
    const ry = ref(props.ry);
    const rz = ref(props.rz);
    const px = ref(props.x);
    const py = ref(props.y);
    const pz = ref(props.z);
    const s = ref(props.s);
    const object = props.object;

    const objectProps = { s, rx, ry, rz, px, py, pz };

    const { material } = useBaseball({ object });
    const { isOverride } = useSceneObject({ object, props, objectProps, name: 'Baseball' });

    watchEffect(() => {
        const val = isOverride.value;
        material.uMaskRoughnessFactor = val ? 0 : 0.8;
        material.uMaskMetalnessFactor = val ? 1 : 0.3;
        material.uUseMaskColor = !val;
    });

    watchEffect(() => {
        material.uMaskColor.set(stitchesColor.value);
    });

    const modelExport = useModelExporter();

    if (!modelExport) {
        // usePane(
        //     [
        //         { name: 'stitchesColor', value: stitchesColor },
        //         { name: 'px', value: px, options: { min: -1, max: 1, step: 0.01 } },
        //         { name: 'py', value: py, options: { min: -1, max: 1, step: 0.01 } },
        //         { name: 'pz', value: pz, options: { min: -4, max: 1, step: 0.01 } },
        //         { name: 's', value: s, options: basePaneOptions },
        //         { name: 'rx', value: rx },
        //         { name: 'ry', value: ry },
        //         { name: 'rz', value: rz, options: { min: 0, max: 1, step: 0.01 } },
        //     ],
        //     { title: 'Baseball', expanded: false }
        // );
    }
</script>
